import { render } from "./Customer2.vue?vue&type=template&id=fda9069c"
import script from "./Customer2.vue?vue&type=script&lang=js"
export * from "./Customer2.vue?vue&type=script&lang=js"

import "./Customer2.vue?vue&type=style&index=0&id=fda9069c&lang=css"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__